// ─── El idioma con que ARRANCA la app ───────────────────────────────────────
// La elección del usuario vive en el store de la interfaz (`dosfilos-ui`, en
// localStorage: `language` y `languageExplicit`). Antes solo se aplicaba cuando
// alguien llamaba a `changeLanguage` —el panel en un efecto, el login en el
// suyo—, así que al recargar la app arrancaba en español y recién después
// cambiaba; el portal no lo aplicaba nunca. Acá se lee ANTES de iniciar i18n:
// el primer render ya sale en el idioma elegido, sin parpadeo.
//
// Solo una elección EXPLÍCITA cuenta. Sin ella, nada cambia: español por
// defecto, el idioma del seminario con `graduation_audit` (app-shell) y la
// detección del navegador en el login (use-funnel-language).

export type InitialLanguage = 'es' | 'en';

export const UI_STORAGE_KEY = 'dosfilos-ui';

/** El idioma elegido explícitamente, a partir de lo guardado por el store; o
 *  undefined si no hay elección (o lo guardado no se entiende). */
export function explicitLanguageFrom(raw: string | null | undefined): InitialLanguage | undefined {
  if (!raw) return undefined;
  try {
    const state = (
      JSON.parse(raw) as { state?: { language?: unknown; languageExplicit?: unknown } }
    ).state;
    if (state?.languageExplicit !== true) return undefined;
    return state.language === 'en' || state.language === 'es' ? state.language : undefined;
  } catch {
    return undefined;
  }
}

/** Lo guardado en este navegador, si se puede leer (sin localStorage —tests,
 *  modo privado estricto— no hay elección). */
export function storedExplicitLanguage(): InitialLanguage | undefined {
  try {
    return explicitLanguageFrom(globalThis.localStorage?.getItem(UI_STORAGE_KEY));
  } catch {
    return undefined;
  }
}
